
<div :class="['report-download-form', {'is-visible': visible}]">
  <button type="button" class="report-download-form__close" @click="hideForm">
    <i class="icon icon--close--pink"></i>
  </button>

  <div class="report-download-form__container">
    <div class="inner-wrapper">
      <form action="register.html" class="diaceutics-form" @submit="onSubmit">
        <div class="diaceutics-form__upper">
          <div class="diaceutics-form__left">
            <h2>Complete this form to download "{{article.title}}"</h2>
          </div>
          <div class="diaceutics-form__right">
            <div class="success" v-if="success">
              <h3 class="thank-you">Thank you</h3>
              <p class="success-text">We've sent a link to your e-mail address to download the report, you can also use the download link below.</p>
              <a :href="article.attachment_url" target="_blank" rel="noopener nofollower" class="button button--filled--blue">Download Report</a>
            </div>

            <div class="form" v-if="!success"> 
              <div class="form__row">
                <div class="form__field">
                  <label for="name">Name</label>
                  <input type="text" name="name" id="name" required v-model="form_submission.name">
                  <div class="error" v-if="errors.name">{{ errors.name }}</div>
                </div>
              </div>

              <div class="form__row">
                <div class="form__field">
                  <label for="email">Email</label>
                  <input type="email" name="email" id="email" required v-model="form_submission.email">
                  <div class="error" v-if="errors.email">{{ errors.email }}</div>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="diaceutics-form__lower" v-if="!success">
          <button type="submit" class="button button--large button--form-submit button--form-submit--filled--blue">Download Report</button>
        </div>
      </form>
    </div>
  </div>
</div>
